import {
    ScheduleDocumentType,
    canScheduleDocument,
} from "@common/helpers/domains/accounting/scheduleDocumentFit";
import {
    ExpenseSubMode,
    ScheduleType,
} from "@common/types/domains/accounting/schedule";

interface DocumentFitTemplate {
    type: ScheduleType;
    expenseSubMode?: ExpenseSubMode | null;
}

/** Expense policies stay hidden while expense schedules are off. */
export function canOfferTemplateForDocument(options: {
    template: DocumentFitTemplate;
    documentType: ScheduleDocumentType;
    isExpensesEnabled: boolean;
}): boolean {
    const { template } = options;
    if (!options.isExpensesEnabled && template.type === ScheduleType.expense) {
        return false;
    }
    return canScheduleDocument({
        template,
        documentType: options.documentType,
    });
}

/** The policies an invoice's or bill's Schedule picker offers. */
export function filterTemplatesForDocument<
    TTemplate extends DocumentFitTemplate,
>(options: {
    templates: TTemplate[];
    documentType: ScheduleDocumentType;
    isExpensesEnabled: boolean;
}): TTemplate[] {
    return options.templates.filter((template) =>
        canOfferTemplateForDocument({
            template,
            documentType: options.documentType,
            isExpensesEnabled: options.isExpensesEnabled,
        }),
    );
}
